/**
 * Maps extracted upload rows to API `files` entries for document-format / HR-bot sends.
 * For {@link import('api/models/DocumentFormat').type} `single-pdf`, each row must include `pageNum` (1-based).
 *
 * @param {Array<object>} rows - Rows with `attachment`, `employee`, optional `pageNum`, `dni`, …
 * @param {object} format - Document format (`type`, `sendBy`, `encryptPdfWithDni`, …)
 * @param {object} userItems - Merged with each row for `getFileName`
 * @param {(row: object, format: object) => string} getFileName
 * @param {{ includePassword?: (row: object) => boolean }} [options]
 */
export function mapExtractedFilesToSendRows(rows, format, userItems, getFileName, options = {}) {
  const { includePassword = a => !!a.dni } = options;
  const sendBy = format.sendBy;

  return rows.map(a => {
    const userId =
      typeof a.employee?.user === 'object' && a.employee?.user !== null
        ? a.employee.user._id
        : a.employee?.user;

    const useEmployeeId = sendBy === 'id' || a.routedByDni;

    return {
      attachment: a.attachment,
      ...(format.type === 'single-pdf' ? { pageNum: a.pageNum } : {}),
      ...(useEmployeeId ? { employeeId: a.employee.id } : { user: userId }),
      ...(includePassword(a) ? { password: a.dni } : {}),
      fileName: getFileName({ ...a, ...userItems }, format),
    };
  });
}
